import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { styleBlock } from "../styleBlock";
import InfoIcon from "../assets/icons/Info.svg";
import Tooltip from "../Tooltip";
export default class PasswordIndicator extends React.PureComponent {
    render() {
        const { label, value, tooltip, className } = this.props;
        const classNames = styleBlock("passwordindicator");
        const cn = classNames({}).mix([className]);
        const isSet = (level) => {
            return "level level-" + level + (value && value > level - 1 ? " level-set" : "");
        };
        return (React.createElement("div", { className: cn.toString() },
            React.createElement(Row, { noGutters: true, className: "mb-2" },
                React.createElement(Col, { className: isSet(1) }),
                React.createElement(Col, { className: isSet(2) }),
                React.createElement(Col, { className: isSet(3) })),
            React.createElement(Row, { noGutters: true },
                React.createElement(Col, { xs: 10 },
                    React.createElement("span", { className: "level-status" }, label)),
                React.createElement(Col, { xs: 2, className: "text-right" }, tooltip && (React.createElement(Tooltip, { id: "pitooltip", tooltip: tooltip },
                    React.createElement("img", { src: InfoIcon, className: "cursor-help" })))))));
    }
}
//# sourceMappingURL=index.js.map